
import { css } from 'lit';
export default css`
.awards-block {
  padding: 60px 0;
  position: relative;
}
  
  .awards-block__container {
    width: calc(100% - 30px);
    max-width: 1046px;
    margin: 0 auto;
    display: flex;
    flex-direction: column;
    flex-wrap: wrap;
  }
  
  @media (min-width: 640px) {
  
  .awards-block__container {
      width: calc(100% - 50px)
  }
    }
  
  @media (min-width: 768px) {
  
  .awards-block__container {
      width: calc(100% - 100px)
  }
    }
  
  @media (min-width: 1024px) {
  
  .awards-block__container {
      flex-direction: row
  }
    }
  
  .awards-block__left {
    color: white;
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    min-width: 283px;
  }
  
  @media (min-width: 1024px) {
  
  .awards-block__left {
      width: 30%
  }
    }
  
  .awards-block__right {
    width: 100%;
    display: flex;
  }
  
  @media (min-width: 1024px) {
  
  .awards-block__right {
      width: 70%
  }
    }
  
  .awards-block__heading {
    color: #6B1F99;
    font-family: Lato;
    font-size: 28px;
    font-style: normal;
    font-weight: 700;
    line-height: 129%; /* 36.12px */
    margin-bottom: 20px;
  }
  
  .awards-block__images {
    width: 100%;
    display: flex;
    gap: 15px;
    justify-content: space-between;
    align-items: center;
    flex-direction: column;
  }
  
  @media (min-width: 768px) {
  
  .awards-block__images {
      flex-direction: row
  }
    }
  
  .awards-block__images .image-wrapper {
      flex: 50%;
      display: flex;
      align-items: center;
      min-width: 150px;
      width: 150px;
      max-width: 150px;
    }
`;